import { IonImg, IonModal } from '@ionic/react';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const CoinsUpsaleModalStyles = styled(IonModal)`
  --border-radius: 0;

  ion-content {
    --background: linear-gradient(
      0deg,
      #2b0e21 0%,
      #14111e 49.18%,
      #1e0f34 100%
    );

    &::part(scroll) {
      padding: 20px 16px;
    }
  }
`;

export const ImageStyles = styled.div`
  max-width: 343px;
  width: 100%;
  aspect-ratio: 343/136;
  margin: 0 auto 32px;

  ion-img {
    width: 100%;
    height: 100%;
  }
`;

export const TitleStyles = styled(UiTypography)`
  margin-bottom: 12px;
`;

export const SubtitleStyles = styled(UiTypography)`
  margin-bottom: 44px;
`;

export const BannerStyles = styled.div`
  max-width: 343px;
  width: 100%;
  aspect-ratio: 343/136;
  margin: 0 auto 24px;
  padding: 24px 32px;
  display: flex;
  align-items: center;
  gap: 24px;
  position: relative;
  border-radius: 24px;
  border: 1px solid var(--border-color-secondary);
  background: rgba(255, 255, 255, 0.05);

  .banner-content {
  }
`;

export const BannerImageStyles = styled(IonImg)`
  max-width: 112px;
  width: 100%;
  aspect-ratio: 112/71;
`;

export const BannerContentStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BannerContentPriceStyles = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BubberSaleLabelStyles = styled(UiTypography)`
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--color-primary-main);
  color: var(--color-white);
  padding: 4px 16px;
  border-radius: 40px;
  background: linear-gradient(90deg, #f31d6b 0%, #803eff 100%);
`;

export const ActionButtonsStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
